<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :showGoBack="true"
      :title="'Edit Personal Info'"
    />

    <main
      class="scrollable container"
      :style="{paddingTop: '10px'}"
    >
      <div
        :style="{
          width: '70px',
          height: '70px',
          margin: '0px auto',
          marginBottom: '30px',
          position: 'relative',
        }"
        class="center"
      >
        <img
          alt="avatar"
          src="https://george-fx.github.io/apitex_api/assets/users/01.png"
          :style="{
            width: '100%',
            height: '100%',
            borderRadius: '50%',
          }"
        />
        <div
          :style="{
            backgroundColor: 'var(--main-dark)',
            width: '100%',
            height: '100%',
            position: 'absolute',
            inset: '0',
            borderRadius: '50%',
            opacity: '0.5',
          }"
        />
        <component
          :is="CameraSvg"
          :style="{position: 'absolute'}"
        />
      </div>
      <Input
        :leftIcon="UserSvg"
        :placeholder="'Enter your name'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="PhoneSvg"
        :placeholder="'Enter your phone number'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="MailSvg"
        :placeholder="'Enter your email'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="InputCalendarSvg"
        :placeholder="'MM/DD/YYYY'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="MapPinSvg"
        :placeholder="'Enter your address'"
        :containerStyle="{marginBottom: '14px'}"
      />
      <Button
        :title="'Save'"
        :style="{marginBottom: '20px'}"
        @click="$router.go(-1)"
      />
    </main>
  </div>
</template>

<script setup>
// hooks
import {useOpacity} from '@/hooks';

// components
import {Header} from '@/components';
import {Input} from '@/components';
import {Button} from '@/components';
import {Background} from '@/components';

// svg
import {UserSvg} from '@/assets/svg';
import {MailSvg} from '@/assets/svg';
import {PhoneSvg} from '@/assets/svg';
import {CameraSvg} from '@/assets/svg';
import {MapPinSvg} from '@/assets/svg';
import {InputCalendarSvg} from '@/assets/svg';

const opacity = useOpacity();
</script>
